"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
const common_helpers_1 = require("../../functions/src/common-helpers");
__export(require("../../functions/src/resource-types"));
const serviceUrls = {
    dev: "http://localhost:5000/api/v1/resources",
    staging: "https://token-service-staging.firebaseapp.com/api/v1/resources",
    production: "https://token-service-62822.firebaseapp.com/api/v1/resources"
};
const getEnv = () => {
    if (typeof window === "undefined") {
        throw new Error("env must be set in options when running as node library");
    }
    const { host } = window.location;
    if (host.match(/staging\./)) {
        return "staging";
    }
    if (host.match(/concord\.org/)) {
        return "production";
    }
    return "dev";
};
const getServiceUrlFromEnv = (env) => {
    return serviceUrls[env];
};
const getServiceUrlFromQueryString = () => {
    if (typeof window === "undefined") {
        return undefined;
    }
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === "token-service-url") {
            const envOrUrl = decodeURIComponent(pair[1]);
            // allow both use of environment names and literal urls for the value
            return getServiceUrlFromEnv(envOrUrl) || envOrUrl;
        }
    }
    return undefined;
};
class TokenServiceClient {
    constructor(options) {
        const { jwt, serviceUrl } = options;
        this.jwt = jwt;
        this.env = options.env || getEnv();
        this.serviceUrl = getServiceUrlFromQueryString() || serviceUrl || getServiceUrlFromEnv(this.env) || serviceUrls.production;
        if ("fetch" in options) {
            this.fetch = options.fetch;
        }
        if (typeof window === "undefined" && !this.fetch) {
            throw new Error("fetch must be set in options when running as node library");
        }
    }
    static get FirebaseAppName() {
        return "token-service";
    }
    listResources(options) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("GET", this.url("/", options))
                .then(resolve)
                .catch(reject);
        });
    }
    getResource(resourceId) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("GET", this.url(`/${resourceId}`))
                .then(resolve)
                .catch(reject);
        });
    }
    createResource(options) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("POST", this.url("/"), { body: options })
                .then(resolve)
                .catch(reject);
        });
    }
    updateResource(resourceId, options) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("PATCH", this.url(`/${resourceId}`), { body: options })
                .then(resolve)
                .catch(reject);
        });
    }
    // TODO: NB: This only deletes firestore record of the resource …
    deleteResource(resourceId) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("DELETE", this.url(`/${resourceId}`))
                .then(resolve)
                .catch(reject);
        });
    }
    getCredentials(resourceId, readWriteToken) {
        return new Promise((resolve, reject) => {
            return this.fetchFromServiceUrl("POST", this.url(`/${resourceId}/credentials`), { readWriteToken })
                .then(resolve)
                .catch(reject);
        });
    }
    getReadWriteToken(resource) {
        return common_helpers_1.getRWTokenFromAccessRules(resource);
    }
    getPublicS3Path(resource, filename = "") {
        const { publicPath } = resource;
        return `${publicPath}${filename}`;
    }
    getPublicS3Url(resource, filename = "") {
        const { publicUrl } = resource;
        return `${publicUrl}${filename}`;
    }
    url(root, query = {}) {
        query.env = this.env;
        const keyValues = Object.keys(query)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
            .join('&');
        return `${root}?${keyValues}`;
    }
    fetchFromServiceUrl(method, path, options) {
        return new Promise((resolve, reject) => {
            const url = `${this.serviceUrl}${path}`;
            const requestOptions = {
                method,
                headers: {
                    "Content-Type": "application/json"
                }
            };
            const authToken = (options === null || options === void 0 ? void 0 : options.readWriteToken) || this.jwt;
            if (authToken) {
                requestOptions.headers["Authorization"] = `Bearer ${authToken}`;
            }
            if (options === null || options === void 0 ? void 0 : options.body) {
                requestOptions.body = JSON.stringify(options.body);
            }
            return (this.fetch || fetch)(url, requestOptions)
                .then((resp) => resp.json())
                .then((json) => {
                if (json.status === "success") {
                    resolve(json.result);
                }
                else {
                    reject(json.error || json);
                }
            })
                .catch(reject);
        });
    }
}
exports.TokenServiceClient = TokenServiceClient;
//# sourceMappingURL=client.js.map